import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { Animated, StyleSheet, View } from 'react-native';


type ProgressProps = {
  step: number;
  steps: number;
  height: number;
  color?: string;
  secondaryColor?: string;
};

const Progress = ({ step, steps, height, color,secondaryColor }: ProgressProps) => {
  const [width, setWidth] = React.useState(0);
  const animatedValue = React.useRef(new Animated.Value(-1000)).current;
  const reactive = React.useRef(new Animated.Value(-1000)).current;
  const colorBar = color? color: '#fff';
  const secondaryColorBar = secondaryColor? secondaryColor: '#fff';

  // Ensure we have valid numbers to prevent NaN issues
  const safeStep = Number.isFinite(step) ? step : 0;
  const safeSteps = Number.isFinite(steps) && steps > 0 ? steps : 1;

  React.useEffect(() => {
    Animated.timing(animatedValue, {
      toValue: reactive,
      duration: 300,
      useNativeDriver: true,
    }).start();
  }, [animatedValue, reactive]);

  React.useEffect(() => {
    const translateX = -width + (width * safeStep) / safeSteps;
    // Additional safety check to ensure translateX is a valid number
    if (Number.isFinite(translateX)) {
      reactive.setValue(translateX);
    }
  }, [safeStep, width, safeSteps, reactive]);

  return (
    <View
      onLayout={e => {
        const newWidth = e.nativeEvent.layout.width;
        setWidth(newWidth);
      }}
      style={[styles.progressContainer, { height }]}
    >
      <Animated.View
        style={[
          styles.progress,
          {
            height,
            transform: [{ translateX: animatedValue }],
          },
        ]}
      >
        <LinearGradient start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }} colors={[colorBar, secondaryColorBar]} style={{width, height, borderRadius:50}} />
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  progressContainer: { backgroundColor: 'rgba(255,255,255,0.33)', overflow: 'hidden' },
  progress: { width: '100%', position: 'absolute', left: 0, top: 0 },
});

export default Progress;
